import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_StartLabelDetectionCommand, se_StartLabelDetectionCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class StartLabelDetectionCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "StartLabelDetection", {})
    .n("RekognitionClient", "StartLabelDetectionCommand")
    .f(void 0, void 0)
    .ser(se_StartLabelDetectionCommand)
    .de(de_StartLabelDetectionCommand)
    .build() {
}
